import { whiteTheme } from 'modules/hairmakeup/styles/themes/whiteTheme';
import styled from 'styled-components';

export const MaxWidth = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1480px;
  width: 100%;
  margin: 0 auto;
  flex-wrap: wrap;
  padding: 28px 140px;
  position: fixed;
  top: 40px;
  left: 0;
  right: 0;
  z-index: 1002;
  background-color: #fff;
  ${whiteTheme.media.laptop} {
    padding-left: 20px;
    padding-right: 20px;
  }
  ${whiteTheme.media.tablet} {
    position: static;
    display: flex;
    flex-direction: column;
    align-content: flex-start;
    align-items: flex-start;
    order: 1;
    max-width: 500px;
    height: auto;
    top: 0;
    padding: 25px 20px 0 50px;
    margin: 0;
    transform: translateX(-100%);
    transition: 0.4s;
    & > :nth-child(1) {
      display: flex;
      pointer-events: all;
      opacity: 1;
      width: 100%;
      margin: 0 -10px 20px;
    }
  }
  ${whiteTheme.media.mobileM} {
    padding: 80px 17.5px 0;
  }
`;

export const HeaderWrap = styled.header`
  width: 100%;
  padding-top: 100px;
  margin-bottom: 166px;
  & > :nth-child(5) {
    display: none;
  }
  ${whiteTheme.media.tablet} {
    display: flex;
    flex-direction: column;
    left: 0;
    height: 100%;
    max-height: 100px;
    position: fixed;
    z-index: 1001;
    background-color: #fff;
    overflow: hidden;
    transition: 0.4s;
    &[open] {
      max-height: 100%;
      overflow: scroll;
    }
    &[open] > :nth-child(2),
    &[open] > :nth-child(1) {
      transform: translateX(0);
    }
    & > :nth-child(5) {
      display: block;
    }
    &::after {
      content: '';
      width: 100%;
      height: 80px;
      position: fixed;
      top: 0;
      left: 0;
      background-color: #fff;
      z-index: 1003;
    }
  }
  ${whiteTheme.media.mobileM} {
    padding-top: 0px;
    max-height: 70px;
  }
`;

export const LogoContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 105px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1001;
  padding: 30px 0;
  background-color: #fff;
  ${whiteTheme.media.tablet} {
    top: 0;
    z-index: 1004;
  }
`;

export const ButtonsContainer = styled.div`
  display: flex;
  margin-left: -5px;
  margin-right: -5px;
  align-items: center;
  position: relative;
  ${whiteTheme.media.tablet} {
    order: 2;
    margin: 0;
  }
`;
